import { memo } from 'react';
import { type NodeProps } from 'reactflow';
import { Sparkles } from 'lucide-react';
import { BaseNodeUI } from './BaseNodeUI';

export const AISummarizerNode = memo(({ data, selected }: NodeProps) => (
    <BaseNodeUI
        title={data?.label || 'AI Summarizer'}
        icon={Sparkles}
        colorClass="from-violet-500 to-violet-700"
        bgClass="bg-gradient-to-br from-violet-500 to-violet-700"
        selected={selected}
        isRunning={data?.executionStatus === 'Running'}
        executionStatus={data?.executionStatus}
        isSource={false}
        isTarget={true}
        rowsProcessed={data?.rowsAffected}
    />
));
AISummarizerNode.displayName = 'AISummarizerNode';
export default AISummarizerNode;
